module.exports = __webpack_public_path__ + "static/media/wom-7950-dcto.8f5ede66.svg";